"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackAction = void 0;

var _browserRum = require("@datadog/browser-rum");

const trackAction = (actionName, actionData) => {
  _browserRum.datadogRum.addAction(actionName, actionData);

  return;
};

exports.trackAction = trackAction;